import { Message } from "element-ui";
import { getUnlimitProtect } from "@/api/common-server.js";

const actions = {
  async decryptPhone({}, encryptionInfo) {
    try {
      if (!encryptionInfo) return undefined;
      const rawValue = String(encryptionInfo);
      if (!/[a-zA-Z]+/.test(rawValue)) return encryptionInfo;
      const { code, data, message } = await getUnlimitProtect({
        encryptionInfo,
      });
      if (code == 200) return data;
      Message.error(message);
      return undefined;
    } catch (error) {
      Message.error("手机号解密失败");
      return undefined;
    }
  },
};

export default {
  actions,
};
